var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });



//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/core-js/modules/es7.reflect.define-metadata.js
// module id = ../../../../core-js/modules/es7.reflect.define-metadata.js
// module chunks = 5